export default __webpack_public_path__ + "static/solden-austria-97b80beea08aee71c77a78ba55d7d2fc.jpg";